module.exports = __webpack_public_path__ + "static/media/desktop.982cd96e.png";